import { Breadcrumbs, Link, Stack, TablePagination, Typography } from "@mui/material"
import RefreshButton from "../../../../../common/components/refresh_button"
import PrimaryButton from "../../../../../common/components/primary_button"
import DynamicIcon from "../../../../../common/components/dynamic_icon"
import AlertError from "../../../../../common/components/alert_error"
import { Header } from "./components/header"
import { useMemo } from "react"
import DeleteDialog from "../../../../../common/components/delete_dialog"
import { GenerateContasReceberListaColumns } from "./columns"
import { ContasReceberLista as ModelContasReceberLista } from "../../../domain/models/contas_receber_lista"
import { useContasReceberListaViewModel } from "../../viewModels/contas_receber_lista_view_model"
import { CadastroRecebimentoModal } from "./components/cadastro_recebimento_modal"
import { CopiaContaReceberModal } from "./components/copia_conta_receber_modal"
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar"
import { ReportViewerModal } from "../../../../../common/components/report_viewer_modal"
import { ReportReceberAnaliticoModal } from "./components/report_contas_receber_analitico_modal"
import { ContasReceberDataGrid } from "./components/contas_receber_data_grid"
import { LegendComponent } from "../../../../../common/components/legend_component"
import { LegendItemComponent } from "../../../../../common/components/legend_item_component"
import { LegendIcon } from "../../../../../common/components/legend_icon"


export const ContasReceberLista = () => {

    const viewModel = useContasReceberListaViewModel();

    const columnsDef = useMemo(() => {
        return GenerateContasReceberListaColumns({
            onActionEdit: viewModel.handleContasReceberEdit,
            onActionDelete: viewModel.handleContasReceberDeleteOpenState,
            onActionCopy: viewModel.handleContaReceberCopiaOpenState,
            onActionExportar: viewModel.handleContaReceberExportar
        });
    }, [
        viewModel.handleContasReceberEdit,
        viewModel.handleContasReceberDeleteOpenState,
        viewModel.handleContaReceberCopiaOpenState,
        viewModel.handleContaReceberExportar
    ]);


    return (
        <>
            {/*
             <PageTopBar>
                <ThreeSlotLayout
                    rightSlot={

                    }
                />
            </PageTopBar> 
            */}

            <PageTopBar>
                <ThreeSlotLayout
                    rightSlot={
                        <div className="flex flex-row gap-2 ">

                            <div className="w-[12rem]">
                                <PrimaryButton
                                    buttonColor="red"
                                    onClick={() => viewModel.handleContasReceberDeleteOpenState(null, true)}>
                                    Excluir Selecionados
                                </PrimaryButton>
                            </div>

                            <div className="w-[12rem]">
                                <PrimaryButton
                                    buttonColor="yellow"
                                    onClick={() => viewModel.handleOpenCadastroRecebimentoModal(true)}>
                                    Receber Selecionados
                                </PrimaryButton>
                            </div>

                            <div className="w-[12rem]">
                                <PrimaryButton
                                    buttonColor="yellow"
                                    onClick={() => viewModel.handleOpenReportContasReceberAnaliticoModal(true)}>
                                    Relatório Analítico
                                </PrimaryButton>
                            </div>

                            <div className="w-[220px] ">
                                <PrimaryButton
                                    startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                                    onClick={() => viewModel.handleNewContasReceber()}>
                                    Nova Conta a Receber
                                </PrimaryButton>
                            </div>
                        </div>
                    }
                />
            </PageTopBar>

            <div className="flex w-full gap-2 flex-col md:p-4 px-5 pt-2">
                <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
                    <Link underline="hover" color="inherit">
                        Home
                    </Link>
                    <Link underline="hover" color="inherit">
                        Financeiro
                    </Link>
                    <Typography className="text-primary-green">
                        Cadastro Contas a Receber
                    </Typography>
                </Breadcrumbs>

                <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
                    <div className="flex gap-2 items-center w-full">
                        <h1 className="text-3xl font-medium text-black dark:text-white"> Contas Receber Lista</h1>
                        <RefreshButton onClick={viewModel.handleReload} />
                    </div>


                </div>
                {
                    viewModel.errorMessage !== undefined ? (
                        <div className="w-full">
                            <AlertError
                                messageErro={viewModel.errorMessage}
                                onTryAgain={viewModel.handleReload} />
                        </div>
                    ) : (
                        <>
                            <Header
                                onStatusChange={viewModel.handleStatusChange}
                                onClearFilters={viewModel.handleClearFilters}
                                ddlCentroCusto={viewModel.ddlCentroCusto}
                                ddlCliente={viewModel.ddlCliente}
                                ddlBanco={viewModel.ddlBanco}
                                ddlOrdemCompra={viewModel.ddlOrdemCompra}
                                ddlSubconta={viewModel.ddlSubconta}
                                status={viewModel.filters.status}
                                titulo={viewModel.filters.titulo}
                                nroConta={viewModel.filters.nroConta}
                                selectedIdsCentroCusto={viewModel.filters.idsCentroCusto ?? []}
                                selectedIdsCliente={viewModel.filters.idsCliente ?? []}
                                selectedIdsBanco={viewModel.filters.idsBanco ?? []}
                                selectedIdsOrdemCompra={viewModel.filters.idsOrdemCompra ?? []}
                                selectedIdsSubconta={viewModel.filters.idsSubconta ?? []}
                                dataReceberDe={viewModel.filters.dataReceberDe}
                                dataReceberAte={viewModel.filters.dataReceberAte}
                                dataRecebidoDe={viewModel.filters.dataRecebidoDe}
                                dataRecebidoAte={viewModel.filters.dataRecebidoAte}
                                dataCriacaoDe={viewModel.filters.dataCriacaoDe}
                                dataCriacaoAte={viewModel.filters.dataCriacaoAte}
                                idContratoFinanceiro={viewModel.filters.idContratoFinanceiro}
                                handleIdCentroCustoChange={viewModel.handleIdCentroCustoChange}
                                handleIdClienteChange={viewModel.handleIdClienteChange}
                                handleIdBancoChange={viewModel.handleIdBancoChange}
                                handleIdOrdemCompraChange={viewModel.handleIdOrdemCompraChange}
                                handleIdSubcontaChange={viewModel.handleIdSubcontaChange}
                                handleIdContratoFinanceiroChange={viewModel.handleIdContratoFinanceiroChange}
                                handleTituloChange={viewModel.handleTituloChange}
                                handleDataReceberRangeChange={viewModel.handleDataReceberRangeChange}
                                handleDataRecebidoRangeChange={viewModel.handleDataRecebidoRangeChange}
                                handleDataCriacaoRangeChange={viewModel.handleDataCriacaoRangeChange}
                                handleNroContaChange={viewModel.handleNroContaChange}

                            />
                            <Stack spacing={0}>
                                <div className="w-full flex flex-row justify-between items-stretch">
                                    <div className="flex flex-col flex-wrap justify-end">
                                        <LegendComponent>
                                            <LegendItemComponent
                                                icon={<LegendIcon color='gray' title='EA' />}
                                                label='Em Aberto' />

                                            <LegendItemComponent
                                                icon={<LegendIcon color='green' title='R' />}
                                                label='Recebido' />

                                            <LegendItemComponent
                                                icon={<LegendIcon color='yellow' title='O' />}
                                                label='Outros' />

                                            <LegendItemComponent
                                                icon={<LegendIcon color='red' title='A' />}
                                                label='Atrasada' />

                                            <LegendItemComponent
                                                icon={<LegendIcon color='blue' title='PA' />}
                                                label='Recebimento Parcial' />
                                        </LegendComponent>
                                    </div>

                                    <div className="flex flex-col justify-between flex-1">
                                        <TablePagination
                                            component="div"
                                            count={viewModel.pagination.totalItems}
                                            page={viewModel.pagination.page - 1}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            onPageChange={(_, p) => viewModel.handlePageChange(p)}
                                            rowsPerPage={viewModel.pagination.rowsPerPage}
                                            onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))} />
                                    </div>
                                </div>

                                <ContasReceberDataGrid
                                    valoresContasMes={viewModel.valoresContasMes}
                                    tableName="contas_Receber_lista"
                                    disableColumnMenu={false}
                                    showToolbar={true}
                                    disableRowSelectionOnClick={true}
                                    getRowId={(row: ModelContasReceberLista) => row.idContasReceber}
                                    columns={columnsDef}
                                    loading={viewModel.loading}
                                    checkboxSelection={true}
                                    onRowSelectionModelChange={viewModel.handleRowSelectionModelChange}
                                    rowSelectionModel={viewModel.rowSelectionModel}
                                    rows={viewModel.contasReceberLista}
                                    rowCount={viewModel.contasReceberLista.length}
                                    getRowHeight={() => 'auto'}
                                    pageSizeOptions={[10, 25, 50, 100]}
                                    paginationMode="server"
                                    paginationModel={{
                                        page: viewModel.pagination.page,
                                        pageSize: viewModel.pagination.rowsPerPage,
                                    }}
                                    pinnedColumns={{
                                        left: ["__check__"],
                                        right: ['idContasReceber'],
                                    }}

                                />

                                <TablePagination
                                    component="div"
                                    count={viewModel.pagination.totalItems}
                                    page={viewModel.pagination.page - 1}
                                    onPageChange={(_, p) => viewModel.handlePageChange(p)}
                                    rowsPerPageOptions={[10, 25, 50, 100]}
                                    rowsPerPage={viewModel.pagination.rowsPerPage > 0 ? viewModel.pagination.rowsPerPage : 25}
                                    onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
                                />
                            </Stack>

                            <DeleteDialog
                                open={viewModel.openDeleteModal}
                                onClose={() => viewModel.handleContasReceberDeleteOpenState(null, false)}
                                title={`Você realmente deseja excluir este item?`}
                                onDelete={viewModel.handleConfirmarDeletarContasReceber} />

                            <CadastroRecebimentoModal
                                open={viewModel.openCadastroRecebimentoModal}
                                saving={viewModel.saving}
                                valorTotalRecebido={viewModel.valorTotalRecebido} // viewModel.getTotalValorRecebido()}
                                ddlBanco={viewModel.ddlBanco}
                                onSubmit={viewModel.handleCadastroRecebimentoSubmit}
                                onClose={() => viewModel.setOpenCadastroRecebimentoModal(false)}

                            />

                            <CopiaContaReceberModal
                                open={viewModel.openCopiaContaReceberModal}
                                saving={viewModel.saving}
                                selectedIdContaReceber={viewModel.selectedIdContaReceberCopia ?? 0}
                                titulo={viewModel.tituloContaReceberCopia ?? ''}
                                onSubmit={viewModel.handleSubmitContaReceberCopia}
                                onClose={() => viewModel.setOpenCopiaContaReceberModal(false)}

                            />

                            <ReportViewerModal
                                reportViewerState={viewModel.reportViewerState}
                            />

                            <ReportReceberAnaliticoModal
                                open={viewModel.openReportContasReceberAnaliticoModal}
                                loading={viewModel.loading}
                                saving={viewModel.saving}
                                ddlBanco={viewModel.ddlBanco}
                                ddlCentroCusto={viewModel.ddlCentroCusto}
                                ddlSubconta={viewModel.ddlSubconta}
                                ddlCliente={viewModel.ddlCliente}
                                filtros={viewModel.filtroContasReceberAnalitico ?? null}
                                onClose={viewModel.handleOpenReportContasReceberAnaliticoModal}
                                onSubmit={viewModel.handleReportContasReceberAnaliticoSubmit}
                                onSubmitColumns={viewModel.handleReportContasReceberAnaliticoColumnsSubmit}

                            />

                        </>
                    )
                }

            </div >
        </>
    )
}
